import { gql } from '@apollo/client';

const GENERATE_API_KEY = gql`
    mutation GenerateApiKey($profileId: Int!, $environment: String!) {
        generateApiKey(profileId: $profileId, environment: $environment) {
            clientId
            clientSecret
            error
        }
    }
`;

export default GENERATE_API_KEY;
